module.exports = __webpack_public_path__ + "img/weddings_16_V.254602f8.webp";